// @flow
// eslint-env browser


/**
 * Check if an element is in viewport
 *
 * @export
 * @param {HTMLElement} elem
 * @param {number} [percentage=0]
 * @returns
 */
export function isInViewport(elem: HTMLElement, percentage: number = 0) {
    const windowHeight = document.documentElement ? document.documentElement.clientHeight : 0;
    const { top, height } = elem.getBoundingClientRect();
    return (top + height * (1 - percentage)) >= 0 && (top + height * percentage) <= windowHeight;
}
